import { createParser, parseAsInteger, useQueryState } from 'nuqs';

const parseAsPage = createParser({
  parse: (value) => {
    const page = parseAsInteger.parse(value);
    return page !== null && page >= 1 ? page : null;
  },
  serialize: parseAsInteger.serialize,
});

const pageParser = parseAsPage.withDefault(1).withOptions({ history: 'replace', shallow: false });

export const useSchedulePage = () => useQueryState('page', pageParser);
